export default __webpack_public_path__ + "static/media/1128040325512725.75269c25.jpg";